export async function fetchUserBadge(): Promise<Badge.Item[]> {
  if (!useUserInfo().value.login) {
    return []
  }
  return http
    .get<Badge.Item[]>('/v1/user/user_badges')
    .then((res) => res.data)
    .catch(() => [])
}
